import React from 'react'
import { MoonLoader, ScaleLoader } from 'react-spinners'

const sizeVariants = {
    sm: {
        width: 2,
        height: 20,
    },
    base: {
        width: 2,
        height: 35,
    },
    md: {
        width: 4,
        height: 45,
    },
}

function Loader({ size }: {size?: number} ) {
    return (
        // <ScaleLoader 
        //     color='hsl(var(--primary))' 
        //     speedMultiplier={1} 
        //     margin={3}
        //     radius={10} 
        //     height={sizeVariants[size].height || undefined}
        //     width={sizeVariants[size].width || undefined}
        // />
        <MoonLoader 
            color='hsl(var(--loader-color))' 
            size={size || 30} 
        />
    )
}

export default Loader